import React, { useState, useRef } from "react";
import { Form, Row, Modal, Button as ButtonBootstrap } from "react-bootstrap";
import history from "../../../history";
import userAccount from "../../../../images/common/userAccount.png";
import signInAs from "../../../../images/common/signInAs.png";
import SignOut from "../../../../images/common/SignOut.png";
import Help from "../../../../images/common/help.png";
import userGuide from "../../../../images/common/userGuide.png";
import UserGuide from "../../../../user_guide/DBT_User_Guide_April2021.pdf";
import { ToastContainer, toast } from "react-toastify";
import { config } from "../../../../constants";
import CircleSign from "../../../ui/CircleSign";
import AppConfig from "../../../../config";
import RequestAssistance from "../../../ui/RequestAssistance";
import SetNewPass from "../../../ui/SetNewPass";
import ConfirmationModal from "../../../ui/ConfirmationModal";
import { useEffect } from "react";
import apiClient from '../../../../utils/apiClient';
import AuthService from '../../../../utils/authService';

const url = config.url.URL;

const { forwardRef, useImperativeHandle } = React;

const MenuPopup = forwardRef((props, ref) => {
  const [showUser, setShowUser] = useState(false);
  const [showModal, setshowModal] = useState(false);
  const [showHelp, setshowHelp] = useState(false);
  const [firstName, setFirstName] = useState(""); 
  const [lastName, setLastName] = useState("");
  const [jobPosition, setJobPosition] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showRequestAssistanceModal, setshowRequestAssistanceModal] = useState(false);
  const [showMyAccount, setshowMyAccount] = useState(false);
  const[showReqAssistConfirmationModal, setshowReqAssistConfirmationModal] = useState(false);

  const FirstName = useRef();
  const LastName = useRef();
  const JobTitle = useRef();
  const PhoneNumber = useRef();
  const resProp = useRef();
  const showPass = useRef();

  useImperativeHandle(ref, () => ({
    ToggleMenuSectionHelp,
    ToggleMenuSectionUser,
    setShowUser,
    setshowHelp,
    componentRef,
  }));

  const ToggleMenuSectionHelp = () => {
    setshowHelp(!showHelp);
    setShowUser(false);
  };

  const ToggleMenuSectionUser = () => {
    setShowUser(!showUser);
    setshowHelp(false);
  };

  const closeConfirmationModal = ()=>{
    setShowConfirmationModal(false);
    setshowMyAccount(true);
  }

  const doubleCloseModals=()=>{
    setshowMyAccount(false);
    setShowConfirmationModal(false);
  }

  const  handleClose = () => {
    if((FirstName.current.value != firstName) || (LastName.current.value != lastName) || (JobTitle.current.value != jobPosition) || (PhoneNumber.current.value != phoneNumber) ){
      setShowConfirmationModal(true);
    }else{
      setshowMyAccount(false);
    }
    
};

const handleClickOutside = (event) => {
  if(showPass.current?.showChangePasswordModal) return;
  if(showMyAccount){
  if (componentRef.current && !componentRef.current.contains(event.target)) {
    handleClose()
    }
  }
};

useEffect(() => {
  document.addEventListener("mousedown", handleClickOutside);

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, [handleClickOutside, showMyAccount]);

  const ToggleMenuSectionMyAccount = () => {
    setshowMyAccount(true);
    setShowUser(false);
    if (!showMyAccount) {
      apiClient.get(`${url}/UserMicroservice/byId`)
        .then((response) => {
          const data = response.data;
          if (data) {
            setFirstName(data.firstName);
            setLastName(data.lastName);
            setJobPosition(JSON.parse(data.properties).JobPosition);
            setPhoneNumber(JSON.parse(data.properties).PhoneNumber);
            resProp.current.value = data.properties;
            FirstName.current.value = data.firstName;
            LastName.current.value = data.lastName;
            JobTitle.current.value = JSON.parse(data.properties).JobPosition;
            PhoneNumber.current.value = JSON.parse(data.properties).PhoneNumber;
          }
        });
    }
  };

  const RedirectToSelectProfile = () => {
    if (localStorage.getItem("multiProfiles") == "true") {
      history.push("/signinprofile");
    }
  };
  
  const SignOut = () => {

    /*Test Signing Renew
    const auth = new AuthService();
    auth.testSigninSilent();
    return;
    */
   
    const authType = localStorage.getItem("authType");
    localStorage.removeItem("multiProfiles");
    localStorage.removeItem("token");
    localStorage.removeItem("authType");
    localStorage.removeItem("ProfileId");
    localStorage.removeItem("ProfileName");
    localStorage.removeItem("RoleName");
    localStorage.removeItem("email");

    if (authType === "SSO") {
      const auth = new AuthService();
      auth.logout();
    } else {
      history.push("/login");
      history.block();
    }
  };

  const openCloseModal = () => {
    setshowModal(!showModal);
  };

  const openCloseRequestAssistanceModal = () => {
    //setshowRequestAssistanceModal(!showRequestAssistanceModal);
    if (showRequestAssistanceModal)
      setshowReqAssistConfirmationModal(true);
    else
      setshowRequestAssistanceModal(true);
  };

  const successedRequestAssistanceModal = () => {
    setshowRequestAssistanceModal(false);
  }

  const closeConfirmationReqAssistModal = ()=>{
   setshowReqAssistConfirmationModal(false);
  }

  const doubleCloseReqAssistModals = ()=> {
    setshowRequestAssistanceModal(false);
    setshowReqAssistConfirmationModal(false);
  }

  const handleButtonClick = () => {
    if (showPass.current) {
      showPass.current.openChangePasswordModal();
    }
  };

  const updateAccount = () => {
    console.log(FirstName.current.value);
    console.log(LastName.current.value);
    console.log(JobTitle.current.value);
    console.log(PhoneNumber.current.value);
    console.log(JSON.parse(resProp.current.value));

    let userInfo = {
      FirstName: FirstName.current.value,
      LastName: LastName.current.value,
      Properties: `{"PhoneCode":"${JSON.parse(resProp.current.value).PhoneCode
        }","PhoneNumber":"${PhoneNumber.current.value}","IdentityLevel":"${JSON.parse(resProp.current.value).IdentityLevel
        }","IdentityType":"${JSON.parse(resProp.current.value).IdentityType
        }","JobPosition":"${JobTitle.current.value}","PasswordType":${JSON.parse(resProp.current.value).PasswordType
        }}`,
    };

    apiClient.put(`${url}/UserMicroservice/updateUser`, userInfo)
      .then((response) => {
        const data = response.data;
        if (data) {
          toast.success("Account form has been updated");
        }
      });
  };

  const componentRef = useRef();

  return (
    <>
      <div ref={componentRef}>
        <div
          className={
            showUser ? "div-user-sections" : "div-user-sections hidden"
          }
        >
          <div style={{ margin: "20px", marginTop: "25px" }}>
            <b style={{ fontSize: "17px", color: "#002855" }}>
            {AppConfig.brandName} Identifier
            </b>
            <br />
            <div style={{ color: "#002855" }}>
              {localStorage.getItem("email")}
            </div>
            <hr />
            <div
              className="div-user-sections_details"
              style={{ marginTop: "-5px" }}
              onClick={() => ToggleMenuSectionMyAccount()}
            >
              <img style={{ width: "20px" }} src={userAccount} alt="User Account"></img>
              <div style={{ fontSize: "14px" }}>My Account</div>
            </div>
            <div
              className="div-user-sections_details"
              onClick={() => RedirectToSelectProfile()}
            >
              <img style={{ width: "25px" }} src={signInAs}></img>
              <div style={{ fontSize: "14px" }}>Sign in as...</div>
            </div>
            <div
              className="div-user-sections_details"
              style={{ marginBottom: "15px" }}
              onClick={() => SignOut()}
            >
              <img style={{ width: "20px" }} src={SignOut}></img>
              <div style={{ fontSize: "14px" }}>Sign Out</div>
            </div>
          </div>
        </div>

        <div
          className={
            showHelp ? "div-user-sections" : "div-user-sections hidden"
          }
        >
          <div style={{ margin: "20px", marginTop: "25px" }}>
            <b style={{ fontSize: "17px", color: "#002855" }}>Help</b>
            <hr />
            <div
              className="div-user-sections_details"
              style={{ marginTop: "-5px" }}
              onClick={() => openCloseModal()}
            >
              <img style={{ width: "20px" }} src={Help}></img>
              <div style={{ fontSize: "14px" }}>About</div>
            </div>
            <div
              className="div-user-sections_details"
              onClick={() => openCloseRequestAssistanceModal()}
            >
              <img style={{ width: "20px" }} src={Help}></img>
              <div style={{ fontSize: "14px" }}>Request for assistance</div>
            </div>
            <div
              className="div-user-sections_details"
              style={{ marginBottom: "15px" }}
            >
              <a
                className="div-user-sections_details"
                style={{ textDecoration: "none" }}
                href={UserGuide}
                download="DBT_User_Guide_April2021.pdf"
                target="_blank"
              >
                <img style={{ width: "17px" }} src={userGuide}></img>
                <div style={{ fontSize: "14px" }}>User Guide</div>
              </a>
            </div>
          </div>
        </div>

        <div
          className={
            showMyAccount ? "div-user-sections" : " hidden"
          }
                  >
          <div style={{ margin: "20px", marginTop: "25px" }}>
            <b style={{ fontSize: "17px", color: "#002855" }}>
              Account Information
            </b>
            <hr />
            <div style={{ marginBottom: "10px" }}>
              <b style={{ fontSize: "22px", color: "#002855" }}>
              {AppConfig.brandName} Identifier
              </b>
            </div>
            <div style={{ color: "#002855", fontStyle: "italic" }}>
              {localStorage.getItem("email")} <br />
              Current Profile : {localStorage.getItem("ProfileName")} <br />
              Roles : {localStorage.getItem("RoleName")}
            </div>
            <hr />
            <Row>
              <Form.Group className="mb-3 col-md-12" controlId="FirstName">
                <Form.Label style={{ fontSize: "14px", color:"rgb(0, 40, 85)" }}>
                  First Name <CircleSign />
                </Form.Label>
                <Form.Control
                  type="text"
                  ref={FirstName}
                  placeholder="First Name"
                />
              </Form.Group>
            </Row>
            <Row>
              <Form.Group className="mb-3 col-md-12" controlId="LastName">
                <Form.Label style={{ fontSize: "14px", color:"rgb(0, 40, 85)" }}>
                  Last Name <CircleSign />
                </Form.Label>
                <Form.Control
                  type="text"
                  ref={LastName}
                  placeholder="Last Name"
                />
              </Form.Group>
            </Row>
            <Row>
              <Form.Group className="mb-3 col-md-12" controlId="JobTitle">
                <Form.Label style={{ fontSize: "14px", color:"rgb(0, 40, 85)" }}>Job Title</Form.Label>
                <Form.Control
                  type="text"
                  ref={JobTitle}
                  placeholder="Job Title"
                />
              </Form.Group>
            </Row>
            <Row>
              <Form.Group className="mb-3 col-md-12" controlId="PhoneNumber">
                <Form.Label style={{ fontSize: "14px", color:"rgb(0, 40, 85)" }}>
                  Phone Number
                </Form.Label>
                <Form.Control
                  type="text"
                  ref={PhoneNumber}
                  placeholder="Phone Number"
                />
              </Form.Group>
            </Row>
            <div style={{ float: "right" }}>
              <a
                className="div-user-sections_details"
                style={{ textDecoration: "none", fontSize: "13px", color:"rgb(0, 107, 166)" }}
                onClick={handleButtonClick}
              >
                Set New Password
              </a>
            </div>
            <br />
            <br />
            <hr />
            <div style={{ display: "flex" }}>
              <a
                className="div-user-sections_details"
                style={{ textDecoration: "none", fontSize: "13px", color:"rgb(0, 107, 166)" }}
                onClick={updateAccount}
              >
                Update Account
              </a>
              <a
                className="div-user-sections_details"
                style={{
                  textDecoration: "none", fontSize: "13px", color:"rgb(0, 107, 166)",
                  width: "130px",
                  marginLeft: "5px",
                }}
                onClick={() => handleClose()}
                >
                Close
              </a>
            </div>
          </div>
        </div>
      </div>

      <ConfirmationModal show={showConfirmationModal} hide={closeConfirmationModal} doubleCloseModals={doubleCloseModals} msg="Your updates won't be saved. Are you sure you want to leave this page ?"/>

      <Modal show={showModal} onHide={openCloseModal} size="md">
        <Modal.Header closeButton>
          <Modal.Title size="h6">About</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <div style={{ textAlign: "center" }}>
              <b>info³ AdminCenter</b>
              <br />
              Version: 1.1
              <br />
              Warning: This computer program is protected by copyright law and
              international treaties. Unauthorized reproduction or distribution
              of this program, or any portion of it, may result in severe civil
              and criminal penalties, and will be prosecuted to the maximum
              extent possible under law.
              <br />
              <br />
              Copyright 2020 ©info³
            </div>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <ButtonBootstrap
            variant="primary"
            className="btnPrimary"
            onClick={openCloseModal}
          >
            Ok
          </ButtonBootstrap>
        </Modal.Footer>
      </Modal>
      {showRequestAssistanceModal && (
       <RequestAssistance openCloseRequestAssistanceModal={openCloseRequestAssistanceModal}  successed={successedRequestAssistanceModal} showRequestAssistanceModal={showRequestAssistanceModal}/>
      )}
       <SetNewPass ref={showPass} isLogin={false} msgContaint="Please set a new personal password:"/>
       <ConfirmationModal show={showReqAssistConfirmationModal} hide={closeConfirmationReqAssistModal} doubleCloseModals={doubleCloseReqAssistModals} msg="Are you sure you want to leave this page ?" />
  

      <input type="hidden" name="resProp" ref={resProp} />

      <ToastContainer position="bottom-right" />
    </>
  );
});

export default MenuPopup;
